import { render, staticRenderFns } from "./EditBatchUpload.vue?vue&type=template&id=5037a1f6&scoped=true&"
import script from "./EditBatchUpload.vue?vue&type=script&lang=js&"
export * from "./EditBatchUpload.vue?vue&type=script&lang=js&"
import style0 from "./EditBatchUpload.vue?vue&type=style&index=0&id=5037a1f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037a1f6",
  null
  
)

export default component.exports